import NPMPackage from '@/../package.json'
import { Nullable } from '@/types/general'

export interface Update {
    version: string
    changelog: string
}

export const checkForUpdates = async (): Promise<Nullable<Update>> => {
    const update: Update = await (await fetch('https://artifacts.volt.sh/?update')).json()

    const npmVersion: string[] = NPMPackage.version.split('.')
    const updateVersion = update.version.split('.')

    if (npmVersion.some((num, i) => Number(num) < Number(updateVersion[i]))) {
        return update
    }

    return null
}
